// extracted by mini-css-extract-plugin
export default {"l":"_3a96bc2f83"};